<h2  style="text-align:center;margin-bottom: 0;">{{data.title}}</h2>
<mat-dialog-content style="padding-top: 0;">
    <p *ngFor="let messaggio of data.message" style="text-align:center;margin-top:0">    {{messaggio}}</p>
</mat-dialog-content>
<mat-dialog-actions class="my-padding-dialog justify-content-end">
    <app-button label="Chiudi" [fullWidth]="false" (click)="closeModal()" raised></app-button>
</mat-dialog-actions>